import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";

import "core-js/features/array/at";
import "core-js/features/promise/all-settled";
import "core-js/features/promise/with-resolvers";

// Après un nouveau déploiement, l'index.html encore en cache référence d'anciens
// chunks hashés qui n'existent plus → les imports dynamiques (ex. l'éditeur
// d'image lazy-loadé) échouent avec « Failed to fetch dynamically imported
// module ». On recharge une seule fois pour récupérer le nouvel index.html.
// Garde anti-boucle : au plus un rechargement toutes les 10 s.
window.addEventListener("vite:preloadError", (event) => {
  const KEY = "vite-preload-reloaded-at";
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY) || 0);
  } catch {
    /* sessionStorage indisponible (mode privé) : on tente quand même */
  }
  if (Date.now() - last < 10_000) return;
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
  event.preventDefault();
  window.location.reload();
});

const router = createBrowserRouter(
  createRoutesFromElements(<Route path="*" element={<App />} />),
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
